// extracted by mini-css-extract-plugin
export var sliderRange = "_rw-2";
export var sliderRoot = "_rw-0";
export var sliderThumb = "_rw-3";
export var sliderTrack = "_rw-1";